'use client';
import styles from './styles.module.css';
import Image from 'next/image';
import { SOCIAL_LINKS } from '../../../constants/links';
import { useState, useEffect } from 'react';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleMobileNavClick = (target: string) => {
    closeMobileMenu();
    setTimeout(() => {
      const element = document.getElementById(target);
      if (element) {
        const elementPosition = element.offsetTop - 120;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const handleDesktopNavClick = (target: string) => {
    const element = document.getElementById(target);
    if (element) {
      const elementPosition = element.offsetTop - 180;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const startBannerHeight = 150;
      const scrollPosition = window.scrollY;

      if (scrollPosition > startBannerHeight) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.headerContainer}>
        <div className={styles.logoWrap}>
          <div className={styles.logo}>
            <Image
              src="/assets/icons/Logo.svg"
              alt="Студия Звир Диджитал, Zvir Digital"
              width={130}
              height={30}
            />
          </div>
          <span className={styles.brandRu} aria-hidden="true">
            Студия Звир Диджитал
          </span>
        </div>

        <nav className={styles.navigation}>
          <div onClick={() => handleDesktopNavClick('services')} className={styles.navLink}>
            Услуги
          </div>
          <div onClick={() => handleDesktopNavClick('cases')} className={styles.navLink}>
            Кейсы
          </div>
          <div onClick={() => handleDesktopNavClick('contacts')} className={styles.navLink}>
            Контакты
          </div>
        </nav>

        <div className={styles.icons}>
          <a href={SOCIAL_LINKS.TELEGRAM} target="_blank" rel="noopener noreferrer" className={styles.iconButton}>
            <Image
              src="/assets/icons/telegram.svg"
              alt="Telegram"
              width={20}
              height={20}
              className={styles.icon}
            />
          </a>
          <a href={SOCIAL_LINKS.LK} target='_blank' className={styles.iconButton}>
            <Image
              src="/assets/icons/user.svg"
              alt="User"
              width={20}
              height={20}
              className={styles.icon}
            />
          </a>
        </div>

        <div className={styles.mobileHeader}>
          <div className={styles.mobileLogoWrap}>
            <div className={styles.mobileLogo}>
              <Image
                src="/assets/icons/Logo.svg"
                alt="Студия Звир Диджитал, Zvir Digital"
                width={90}
                height={25}
              />
            </div>
            <span className={styles.brandRuMobile} aria-hidden="true">
              Студия Звир Диджитал
            </span>
          </div>

          <div className={styles.mobileIcons}>
            <a href={SOCIAL_LINKS.TELEGRAM} target="_blank" rel="noopener noreferrer" className={styles.mobileTelegram}>
              <Image
                src="/assets/icons/telegram.svg"
                alt="Telegram"
                width={16}
                height={16}
              />
            </a>
            <button className={styles.menuButton} onClick={toggleMobileMenu}>
              Меню
            </button>
          </div>

          <div className={`${styles.mobileMenu} ${isMobileMenuOpen ? styles.open : ''}`}>
            <div onClick={() => handleMobileNavClick('services')} className={styles.mobileNavLink}>
              Услуги
            </div>
            <div onClick={() => handleMobileNavClick('cases')} className={styles.mobileNavLink}>
              Кейсы
            </div>
            <div onClick={() => handleMobileNavClick('contacts')} className={styles.mobileNavLink}>
              Контакты
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
